import { render, staticRenderFns } from "./Vergleichsstatistik.vue?vue&type=template&id=042be83e"
import script from "./Vergleichsstatistik.vue?vue&type=script&lang=js"
export * from "./Vergleichsstatistik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports